import React, { useEffect } from "react";
import logo from "../img/enjuggernaut_logo.png";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../store";
import { useNavigate } from "react-router-dom";
import { JobDetails } from "./JobCard";
import JobCard from "./JobCard";
import { useAuthToken } from "../AuthProvider";
import { TopBar } from "../Topbar";
import { Sidebar } from "../Sidebar";
import { Subscription } from "../Subscription";
import { Tooltip } from "react-tooltip";
import info_mark from "../img/info_mark.svg";
import { toast } from "react-toastify";
import { Drawer } from "@mui/material";
import add_job from "../img/job_add.svg";

export function Jobs() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [jobDetails, setJobDetails] = React.useState<JobDetails[]>([]);
  const { isAuthenticated, token, isLoading, isConfirmed } = useAuthToken();
  const [role, setRole] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [jobCredits, setJobCredits] = React.useState(0);
  const [isEntryOverlayOpen, setisEntryOverlayOpen] = React.useState(false);
  const [isLoadingOverlayOpen, setIsLoadingOverlayOpen] = React.useState(false);
  const [isSubscriptionOverlayOpen, setIsSubscriptionOverlayOpen] =
    React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const updateRedirectUri = (uri: string) => {
    dispatch({
      type: "UPDATE_URI",
      payload: uri,
    });
  };

  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  async function submitJob() {
    if (role.length == 0 || company.length == 0 || description.length == 0) {
      return;
    }

    const apiEndpoint =  "/api/job";

    const formData = new FormData();

    formData.append("title", role);
    formData.append("company", company);
    formData.append("description", description);

    let headers = {};

    if (isAuthenticated) {
      headers = {
        Authorization: `Bearer ${token}`,
      };
    }

    setIsLoadingOverlayOpen(true);

    try {
      // Make a POST request using fetch
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
        headers: headers,
      });

      setisEntryOverlayOpen(false);
      getJobs();

      setCompany("");
      setRole("");
      setDescription("");
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occured.");
    }

    setIsLoadingOverlayOpen(false);
  }

  async function getJobs() {
    if (isLoading) {
      return;
    }

    const apiEndpoint =  "/api/jobs";

    let headers = {};

    if (!isAuthenticated) {
      updateRedirectUri("/jobs");
      navigate("/login");
    } else {
      updateRedirectUri("");

      headers = {
        Authorization: `Bearer ${token}`,
      };

      try {
        // Make a POST request using fetch
        const response = await fetch(apiEndpoint, {
          method: "GET",
          headers: headers,
        });

        if (response.ok) {
          const responseData = await response.json();
          setJobDetails(responseData.job_details);
          setJobCredits(responseData.job_credits);
        } else {
          updateRedirectUri("/jobs");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occured.");
      }
    }
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  React.useEffect(() => {
    if (!isLoading && isAuthenticated) {
      getJobs();
    } else if (!isLoading && !isAuthenticated) {
      updateRedirectUri("/jobs");
      navigate("/login");
    }
  }, [isLoading, isAuthenticated]);

  if (isLoading) {
    return <div className="dark-panel"></div>;
  }

  return (
    <div>
      <header className="header dark-panel visible sticky top-0 z-20 mx-auto flex flex-row items-center justify-between p-2 lg:hidden lg:p-4">
        <img src={logo} className="h-auto w-1/2" alt="logo" />

        <div>
          <button
            onClick={toggleMenu}
            className="text-white hover:text-gray-300 focus:outline-none"
          >
            <svg
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-12 w-12"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </header>

      {isEntryOverlayOpen && (
        <div className="overlay">
          <div className="job-overlay dark-panel w-4/5 lg:w-1/2">
            <div className="flex flex-row justify-between">
              <div className="inline-block w-1/2 pr-4">
                <p className="text-orange pl-3 text-xl font-bold lg:text-2xl xl:text-3xl">
                  ROLE
                </p>
                <textarea
                  value={role}
                  onInput={(event: React.FormEvent<HTMLTextAreaElement>) =>
                    setRole(event.currentTarget.value)
                  }
                  rows={1}
                  className="answer-box mt-3 max-h-min w-full p-5 text-lg lg:text-xl xl:text-2xl"
                  ref={textareaRef}
                  placeholder="Software Engineering Intern"
                />
              </div>
              <div className="inline-block w-1/2 pl-4">
                <p className="text-blue pl-3 text-xl font-bold lg:text-2xl xl:text-3xl">
                  COMPANY
                </p>
                <textarea
                  value={company}
                  onInput={(event: React.FormEvent<HTMLTextAreaElement>) =>
                    setCompany(event.currentTarget.value)
                  }
                  rows={1}
                  className="answer-box mt-3 w-full p-5 text-lg lg:text-xl xl:text-2xl"
                  ref={textareaRef}
                  placeholder="ABC Inc."
                />
              </div>
            </div>
            <div className="inline-block pt-4">
              <p className="text-blue pl-3 text-xl font-bold lg:text-2xl xl:text-3xl">
                DESCRIPTION
              </p>
              <textarea
                maxLength={4000}
                value={description}
                onInput={(event: React.FormEvent<HTMLTextAreaElement>) =>
                  setDescription(event.currentTarget.value)
                }
                rows={5}
                className="answer-box mt-3 w-full p-5 text-2xl"
                ref={textareaRef}
                placeholder="Copy and paste the job description directly in here (max 4,000 characters)."
              />
            </div>
            <div className="my-auto flex flex-row justify-between">
              <button
                className={`${
                  isConfirmed && jobCredits > 0
                    ? "login-button"
                    : "disabled-button"
                } mx-auto mr-4 mt-8 block w-2/3 px-6 font-bold md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl`}
                disabled={!isConfirmed || jobCredits == 0}
                onClick={() => submitJob()}
              >
                Confirm
              </button>
              <button
                className="start-button mx-auto ml-4 mt-8 block w-2/3 px-6 py-2 font-bold md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl"
                onClick={() => setisEntryOverlayOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {isSubscriptionOverlayOpen && (
        <div className="overlay z-10">
          <Subscription open_fn={setIsSubscriptionOverlayOpen} />
        </div>
      )}

      {isLoadingOverlayOpen && (
        <div className="overlay">
          <div className="agreement-content">
            <h2 className="attention-text font-bold">Loading...</h2>
            <h2 className="overlay-text font-bold">
              Please be patient, this could take a moment...
            </h2>
            <div className="text-center">
              <div role="status">
                <svg
                  aria-hidden="true"
                  className="inline h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex min-h-screen w-full max-w-full flex-row">
        <div className="light-panel flex w-full flex-col lg:w-4/5 xl:w-5/6">
          <div className="flex w-full flex-col md:flex-row md:justify-between">
            <div className="flex w-full flex-col">
              <h1 className="tooltip mt-4 line-clamp-1 flex justify-start pl-8 font-code text-lg font-bold text-white md:ml-0 lg:text-xl xl:text-2xl">
                <img src={info_mark} className={`mr-2 scale-75 lg:scale-100`} />
                Job Credits: {jobCredits}
              </h1>
              <Tooltip
                anchorSelect={`.tooltip`}
                className="font-code"
                place="bottom-start"
              >
                The number of jobs you can submit for AI analysis
              </Tooltip>
              {!isConfirmed && (
                <h1 className="pr-4 pt-2 text-right font-code text-sm italic text-red-500">
                  Account not confirmed!
                </h1>
              )}
            </div>
          </div>
          <div className="max-h-screen px-8 py-8 lg:px-16 lg:py-16">
            <div
              className={`grid w-full grid-cols-1 gap-y-8 lg:gap-y-12 ${
                jobDetails.length > 0 ? "visible" : "invisible"
              }`}
            >
              {jobDetails.map((details, index) => (
                <div key={index}>
                  <JobCard
                    company={details.company}
                    title={details.title}
                    uuid={details.uuid}
                    updateFunc={() => getJobs()}
                  />
                </div>
              ))}
            </div>
            <h1
              className={`font-code text-lg font-bold text-[#828282] lg:text-xl xl:text-2xl  ${
                jobDetails.length > 0 ? "invisible" : "visible"
              }`}
            >
              You do not have any tracked jobs. Start by adding one...
            </h1>
          </div>
          <button
            onClick={() => {
              if (jobCredits < 1) {
                toast.error(
                  "Insufficient job credits (consider enjuggernaut+)."
                );
                return;
              }

              if (!isConfirmed) {
                toast.error("Please confirm your account (check your email).");
                return;
              }

              setisEntryOverlayOpen(true);
            }}
          >
            <div className="2xl fixed bottom-5 right-5 z-50 flex h-16 w-16 items-center justify-center rounded-full bg-[#ff8800] shadow-lg lg:right-[22vw] xl:right-[18vw]">
              <img src={add_job} />
            </div>
          </button>
        </div>
        <Drawer anchor="right" open={isOpen} onClose={() => setIsOpen(false)}>
          <Sidebar minimized={false} drawer={true} />
        </Drawer>
        <Sidebar minimized={false} drawer={false} />
      </div>
    </div>
  );
}
